import { OnModalDestroyCustomEvent } from "@lib/events/customEvents";
import { HtmxCustomEvent, HtmxEventDetail } from "@lib/htmx/types";
import { loader } from "@lib/validation/utils";

import htmx from "htmx.org";
declare global {
    interface Window { htmx: htmx; }
}



class ModalManager {
    public modals: Map<string, any>;

    constructor() {
        this.modals = new Map<string, any>();
    }

    public add(name: string, modal: any): any {
        if (!this.modals.has(name)) {
            this.modals.set(name, modal);
        }

        return this.modals.get(name);
    }

    public get(name: string): any {
        return this.modals.get(name) ?? null;
    }

    public remove(name): void {
        if (this.modals.has(name)) {
            this.modals.delete(name);

            const ev = new CustomEvent<OnModalDestroyCustomEvent>("onModalDestroyCustomEvent", {
                detail: { modalKey: name, type: "onModalDestroyCustomEvent" }
            });
            
            document.body.dispatchEvent(ev);
        }
    }

    public CheckAndOpen(event: Event, props: ModalProps) {
        const modal = this.get(props.modalId);

        if (modal) {
            event.preventDefault();
            modal.show();
        }
        return modal;
    }

    public createAndOpen(props: ModalProps, createModalProps: CreateModalProps)
    {
        if (createModalProps?.body?.includes('modal fade modal-as'))
        {
            this.OpenModal({ modalId: "_error-modal"});
            return;
        }

        props.modalId = this.get(props.modalId) == null ? props.modalId : props.modalId + "_1";

        const element = document.createElement("div");
        element.id = props.modalId;
        element.className = "modal fade " + createModalProps.class;
        element.setAttribute("role", "dialog");
        element.innerHTML = `
                <div class="modal-dialog modal-dialog-centered ${createModalProps.size ?? ""}">
                    <div class="modal-content">
                        <div class="modal-header">
                            ${createModalProps.title}
                            <div type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <i class="material-icons mdi mdi-close-circle" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="modal-body">
                            ${createModalProps.body}
                        </div>                        
                    </div>
                </div>`;

        document.querySelector('body')?.appendChild(element);

        if (createModalProps.footer) {
            element.querySelector('.modal-body')?.after(createModalProps.footer);
        }

        props.event = undefined;
        this.OpenModal(props);
    }

    public OpenFirstModal(props: ModalProps) {
        this.createAndOpen(props, { title: props.title ?? "Assortis Data-Entry", body: loader().outerHTML, class: 'modal-as' });
        window.htmx.process(document.body);
    }

    public OpenModal(props: ModalProps) {
        // if its an htmx request and its failed
        if (props.event !== undefined && (props.event.detail.failed || [40, 500].includes(props.event.detail.xhr.status))) {
            const body = props.event.detail.xhr.response;
            props.event = undefined;
            this.createAndOpen(props, { title: "Error fetching resource", body: body, class: 'modal-as' });
            return;
        }
        // @ts-ignore: skipping next line so it will use the bootstrap being added by _layout
        const modalObject = new bootstrap.Modal('#' + props.modalId);
        this.add(props.modalId, modalObject);

        modalObject.show();

        if (props.callback) {
            props.callback();
        }

        const modal = document.getElementById(props.modalId) as HTMLElement;
        modal.addEventListener("hidden.bs.modal", (event) => {
            if (event.currentTarget === event.target) {
                this.CloseModal(props);
            }
        });

        window.htmx.process(document.body);
    }

    public CloseModal(props: ModalProps) {
        // if its an htmx request and its failed        
        if (props.event !== undefined && (props.event.detail.failed || [40, 500].includes(props.event.detail.xhr.status) )) {
            this.createAndOpen(props, { title: "Error fetching resource", body: props.event.detail.xhr.response, class: "modal-as" });
            return;
        }
        
        const modalObject = this.get(props.modalId);
        if (modalObject === null) {
            return;
        }
        
        modalObject.hide();

        if (!props.retainOnClose) {
            document.querySelector("#" + props.modalId)?.remove();
            this.remove(props.modalId);
        }

        if (props.closeEventCallback) {
            props.closeEventCallback();
        }
    }
}

export var modalManager: ModalManager = new ModalManager();

export type CreateModalProps = {
    title: string, 
    class: 'modal-as' | 'modal-action',
    body?: string, 
    footer?: HTMLElement, 
    size?: string
}

type ModalProps = {
    modalId: string,
    title?: string,
    callback?: Function,
    closeEventCallback?: Function, 
    retainOnClose?: boolean,
    event?: CustomEvent<HtmxEventDetail>
}